import { isObject } from '../../../../utilities/helpers';
import {
  BATTERIES_IN_LEASE,
  HAS_NEVER_BEEN_INAPPROPRIATELY_USED,
  HAS_NEVER_BEEN_WRITTEN_OFF_OR_STOLEN,
  HAS_PROOF_OF_PURCHASE,
  OWNED_BY_SELLER_KEY,
} from '../VehicleProfiling.constants';

export const extraValuesToResend = [
  HAS_NEVER_BEEN_INAPPROPRIATELY_USED,
  HAS_NEVER_BEEN_WRITTEN_OFF_OR_STOLEN,
  OWNED_BY_SELLER_KEY,
  HAS_PROOF_OF_PURCHASE,
  BATTERIES_IN_LEASE,
] as const;

export type DataSection = {
  data: Record<string, any>[];
  title: string;
};

export const getDataToResend = (data: DataSection[]) => {
  if (!Array.isArray(data) || !data.length) {
    return [];
  }

  const result = [...extraValuesToResend];

  const checkObject = (obj: Record<string, any>) => {
    Object.entries(obj).forEach(([key, value]) => {
      if (isObject(value)) {
        checkObject(value);
      } else if (key === 'resendOnSummary' && value) {
        if (obj.dpKey) {
          result.push(obj.dpKey);
        }
        if (obj.additionalKey) {
          result.push(obj.additionalKey);
        }
      }
    });
  };

  data.forEach((item) => {
    item.data.forEach((dataItem) => {
      checkObject(dataItem);
    });
  });

  return result.length === extraValuesToResend.length ? [] : result;
};
